import React from 'react';

import { useCycleAd, useSetupAd } from '@client/hooks';
import useLayoutTypeSub from '@client/hooks/useLayoutTypeSub';
import {
  BannerAdObj,
  LayoutType,
  NativeAdObj,
  PlacementId,
  VideoAdObj
} from '@schibsted-nmp/advertising-shared';

import { usePlacementStyling } from '../../../hooks/usePlacementStyling';
import { Placeholder } from '../../placeholder/Placeholder';
import BannerAdComponent from '../banner/BannerAdComponent';
import NativeAdComponent from '../native/NativeAdComponent';
import VideoAdComponent from '../video/VideoAdComponent';

export type AdSwitchProps = {
  containerId: string;
  placementId: PlacementId;
  initialLayoutType?: LayoutType;
};

export function AdSwitchComponent(props: AdSwitchProps) {
  const { placementId, containerId, initialLayoutType } = props;
  const targetId = useCycleAd(placementId);
  const layoutType = useLayoutTypeSub(initialLayoutType || 'grid');

  const { adObj, status } = useSetupAd({
    placementId,
    targetId,
    containerId
  });

  const className = usePlacementStyling(
    placementId,
    containerId,
    targetId,
    adObj,
    status
  );

  if (!adObj) return null;
  switch (adObj?.adType) {
    case 'native':
      return (
        <NativeAdComponent
          adObj={adObj as NativeAdObj}
          id={targetId}
          status={status}
          layoutType={layoutType}
        />
      );
    case 'banner':
      return (
        <BannerAdComponent
          adObj={adObj as BannerAdObj}
          id={targetId}
          className={className}
        />
      );
    case 'video':
      return <VideoAdComponent adObj={adObj as VideoAdObj} id={targetId} />;
    default:
      return <Placeholder id={targetId} />;
  }
}
